import { Typography } from '@mui/material';
import Avatar, { AvatarProps } from 'further-ui/components/Avatar';
import { Column, Row } from 'further-ui/components/Layout';

type Props = Pick<AvatarProps, 'icon'> & {
  name: string;
  subtext?: string;
  avatarSize?: 'md' | 'lg' | 'xl';
  src?: string | null;
  priority?: 'icon' | 'text';
};

const AvatarWithName: React.FC<Props> = ({
  name,
  subtext,
  src,
  icon,
  priority = 'text',
  avatarSize = 'md',
}) => {
  return (
    <Row spacing="xs" centered>
      <Avatar
        icon={icon}
        src={src ?? undefined}
        size={avatarSize}
        text={priority === 'icon' ? undefined : name}
        color="random"
      />
      <Column>
        <Typography variant="inherit">{name}</Typography>
        {subtext ? <Typography variant="body2">{subtext}</Typography> : null}
      </Column>
    </Row>
  );
};

export default AvatarWithName;
